export const environment = {
  patientSessionInactivityMinutes: 10,
  production: true,
  environment: 'Dev',
  cva_url: 'https://devcva-profile.intellitekhealth.com/api/cva-standalone/v1',
  loggerConfig: {
    ipResolutionEndPoint:
      'https://devcva-profile.intellitekhealth.com/api/cva-standalone/v1/client-logger/resolve_ip',
    loggerEndPoint:
      'https://devcva-profile.intellitekhealth.com/api/cva-standalone/v1/client-logger/add_log',
    debug: true,
  },
  cvaUI_url: 'https://devcva-profile.intellitekhealth.com',
  settings: {
    locale: 'en-NZ',
    language: 'en-US',
    zoneIdentifier: 'NZ',
    utcOffset: '+12:00',
  },
  user_management_api_url: 'https://devcva-profile.intellitekhealth.com/um/api',
  landingURL: 'home',
  unauthizedURL: 'auth/unauthorized',
  enc_pass: 'fa895a17cea6f35de3f4065a3faded938a884a019d2e1d479f5cfb2c30d1e6e7',
  enc_alg: 'aes-256-cbc',
  editableTranscripts: true,
  enabledRft: true,
  TEST_PASSWORD: "TestPassword@123",
  TEST_OLD_PASSWORD: "TestOldPassword@123",
  productBy: "IntelliTek Health",
  supportURL: 'https://st21products.atlassian.net/servicedesk/customer/portal/1',
  freeTrialDays: 30,
  maxLicense: 999,
  DEMO_VIDEO_CDN_URL: 'https://devcva-profile.intellitekhealth.com/assets',
  MAX_AUDIO_FILE_SIZE: 500,
  RECOMMENDATIONS: {
    TASKS: false,
    CLASSIFICATIONS: false,
    BILLING_CODES: false,
    PROGRAM_RECOMMENDATION: false,
  },
  ENABLE_RTF_NESTING: false,
  siteKey: '6LfAqH4tAAAAANwwJE4X2vdkKXAO7wvh8q3Fd5TU'
};
